import request from "../utils/request";

function formatDate(date) {
  if (!date) return null;
  if (typeof date === 'string') {
    if (date.includes('T')) return date.split('T')[0];
    return date;
  }
  const d = new Date(date);
  if (isNaN(d.getTime())) return null;
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export async function getOrderLogs(payload) {
  return request.get("Cart/OrderLogs?", {
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      branchId: payload.branch != null || payload.branch != undefined ? payload.branch.id : null,
      productId: payload.product != null ? payload.product.id : null,
      extraId: payload.extra != null ? payload.extra.id : null,
      personalId: payload.personal != null ? payload.personal.id : null,
      orderId: payload.order != null ? (payload.order.id || payload.order) : null,
      branchTableUId: payload.branchTableUId || null,
      tableId: payload.table != null ? payload.table.id : null,
      paymentMethodId: payload.paymentMethod != null ? payload.paymentMethod.id : null,
      minPrice: payload.price != null ? payload.price.min : null,
      maxPrice: payload.price != null ? payload.price.max : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? formatDate(payload.dateRange.startDate) : null,
      startTime: payload.timeRange != null && payload.timeRange.startTime != null ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? formatDate(payload.dateRange.endDate) : null,
      endTime: payload.timeRange != null && payload.timeRange.endTime != null ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      isNavigatedByQuestion: payload.isNavigatedByQuestion
    }
  });
}

export async function getOrderLogsExcel(payload) {
  return request.get("Cart/OrderLogsExcel?", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      branchId: payload.branch != null || payload.branch != undefined ? payload.branch.id : null,
      productId: payload.product != null ? payload.product.id : null,
      extraId: payload.extra != null ? payload.extra.id : null,
      personalId: payload.personal != null ? payload.personal.id : null,
      orderId: payload.order != null ? (payload.order.id || payload.order) : null,
      tableId: payload.table != null ? payload.table.id : null,
      paymentMethodId: payload.paymentMethod != null ? payload.paymentMethod.id : null,
      minPrice: payload.price != null ? payload.price.min : null,
      maxPrice: payload.price != null ? payload.price.max : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? formatDate(payload.dateRange.startDate) : null,
      startTime: payload.timeRange != null && payload.timeRange.startTime != null ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? formatDate(payload.dateRange.endDate) : null,
      endTime: payload.timeRange != null && payload.timeRange.endTime != null ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      isNavigatedByQuestion: payload.isNavigatedByQuestion
    }
  });
}

export async function getOrderLogsExcelForDealer(payload) {
  return request.get("Cart/OrderLogsForDealerExcel?", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      branchId: payload.branch != null || payload.branch != undefined ? payload.branch.id : null,
      productId: payload.product != null ? payload.product.id : null,
      extraId: payload.extra != null ? payload.extra.id : null,
      personalId: payload.personal != null ? payload.personal.id : null,
      orderId: payload.order != null ? (payload.order.id || payload.order) : null,
      tableId: payload.table != null ? payload.table.id : null,
      paymentMethodId: payload.paymentMethod != null ? payload.paymentMethod.id : null,
      minPrice: payload.price != null ? payload.price.min : null,
      maxPrice: payload.price != null ? payload.price.max : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? formatDate(payload.dateRange.startDate) : null,
      startTime: payload.timeRange != null && payload.timeRange.startTime != null ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? formatDate(payload.dateRange.endDate) : null,
      endTime: payload.timeRange != null && payload.timeRange.endTime != null ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      isNavigatedByQuestion: payload.isNavigatedByQuestion
    }
  });
}

export async function getOrderLogsForDealer(payload) {
  return request.get("Cart/OrderLogsForDealer?", {
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      branchId: payload.branch != null || payload.branch != undefined ? payload.branch.id : null,
      productId: payload.product != null ? payload.product.id : null,
      extraId: payload.extra != null ? payload.extra.id : null,
      personalId: payload.personal != null ? payload.personal.id : null,
      orderId: payload.order != null ? (payload.order.id || payload.order) : null,
      tableId: payload.table != null ? payload.table.id : null,
      paymentMethodId: payload.paymentMethod != null ? payload.paymentMethod.id : null,
      minPrice: payload.price != null ? payload.price.min : null,
      maxPrice: payload.price != null ? payload.price.max : null,
      startDate: payload.dateRange && payload.dateRange.startDate ? formatDate(payload.dateRange.startDate) : null,
      startTime: payload.timeRange != null && payload.timeRange.startTime != null ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endDate: payload.dateRange && payload.dateRange.endDate ? formatDate(payload.dateRange.endDate) : null,
      endTime: payload.timeRange != null && payload.timeRange.endTime != null ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      isNavigatedByQuestion: payload.isNavigatedByQuestion
    }
  });
}

export async function getOrderEntries(payload) {
  return request.get("Cart/GetOrderById", {
    params: {
      id: payload,
      orderId: payload
    }
  })
}

export async function getOrderBySID(sid) {
  return request.get("Cart/GetOrderBySID", {
    params: {
      sid: sid
    }
  })
}

export async function setBranchCart(payload) {
  return request.post("Cart/Save", payload)
}

export async function reserveTable(payload) {
  return request.post("Cart/reserve-table/" + payload)
}

export async function unReserveTable(payload) {
  return request.post("Cart/unreserve-table/" + payload)
}

export async function setStatus(payload) {
  return request.post("Cart/set-status", payload)
}

export async function addToCart(payload, tableId) {
  return request.post("Cart/add-to-cart/" + tableId, payload)
}

export async function addToCartFromCart(payload, tableId) {
  return request.post("Cart/add-to-cart-from-cart/" + tableId, payload)
}

export async function removeToCart(entryId, tableId, description) {
  return request.post("Cart/remove-to-cart/" + entryId + "/" + tableId, { description })
}

export async function removeToCartIds(ids, tableId, description) {
  return request.post("Cart/remove-to-cart-by-ids/" + tableId, { ids, description })
}

export async function breakToRow(entryId, tableId) {
  return request.post("Cart/break-to-row/" + entryId + "/" + tableId)
}


/**
 * Merge the cart of the table with the given fromTableId with the
 * cart of the table with the given toTableId.
 *
 * @param {number} fromTableId - The id of the table to be merged.
 * @param {number} toTableId - The id of the table to be merged to.
 * @return {Promise} - The promise of the request.
 */
export async function mergeCart(fromTableId, toTableId, description) {
  return request.post("Cart/merge/" + fromTableId + "/" + toTableId, { description })
}

export async function splitCart(tableId) {
  return request.post("Cart/split/" + tableId)
}

export async function transferCart(fromTableId, toTableId, ids, description) {
  return request.post("Cart/transfer/" + fromTableId + "/" + toTableId, { ids, description })
}

export async function getCarts() {
  return request.get("Cart")
}

export async function getNextOrderNo(tableId) {
  return request.get("Cart/next-order-no/" + tableId)
}

export async function getCartsByTableId(tableId) {
  return request.get("BranchTables/" + tableId)
}

export async function lockTable(tableId) {
  return request.post("Cart/lock-table/" + tableId)
}

export async function releaseTable(tableId) {
  return request.post("Cart/release-table/" + tableId)
}

export function releaseMyLocks() {
  return request.post("Cart/release-my-locks")
}

export const markAdisyonPrinted = (sid) => {
  return request({
    url: `Cart/mark-adisyon-printed/${sid}`,
    method: "post",
  });
};

export const triggerKitchenPrintBySID = (sid, printerName = "Mutfak", tableName = "", isAdisyon = false, on = null) => {
  return request.post("Cart/trigger-kitchen-print-by-sid/" + sid, null, {
    params: {
      printerName: printerName,
      tableName: tableName,
      isAdisyon: isAdisyon
    }
  })
}

export async function changePaymentMethod(payload) {
  return request.post("Cart/ChangePaymentMethod", payload)
}
